import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import CoverageBlock from '../../components/CoverageBlock.js';
import CoverageBlockFull from '../../components/CoverageBlockFull.js';
import store from '../../redux/store.js';

/**
 *
 * @param {*} props
 */
export default function Paramedicals ({ classes, expanded, paramedicals, handleChange, defineCoverageType, showDependentWarning, waivedEHC, hasDeductible }) {
    const combinedMaxType = paramedicals.combinedMaximum !== 0 ? i18n.t(tokens.labels.coverage.upToTheBelowMaximums) : ``;
    const combinedMaxRenewalType =
            paramedicals.combinedMaximum !== 0 ?
                i18n.t(tokens.labels.coverage.combinedMaximumRenewal, { combinedMaximum: numberWithCommas(paramedicals.combinedMaximum) })
                :
                i18n.t(tokens.labels.coverage.maximumRenewal);

    const paramedicalsReimbursementString = i18n.t(tokens.labels.coverage.paramedicalsReimbursement, { paramedicalsReimbursement: paramedicals.reimbursement, combinedMaxType, combinedMaxRenewalType }); 

    const familyCombinedMaximumString = paramedicals.familyCombinedMaximum !== 0 ? i18n.t(tokens.labels.coverage.combinedFamilyMaximum, { combinedMaximum: numberWithCommas(paramedicals.familyCombinedMaximum) }) : null;

    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('paramedicals')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('paramedicals') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.paramedicals) }</Text>
                    {
                        waivedEHC &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "0 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        paramedicals.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : 
                            null
                    }

                    {
                        showDependentWarning &&
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.waivedBenefitForDependents) }
                                </Text>
                            </div>
                    }

                    <div style={classes.row}>
                        <Text small bold margin="10px 0px 10px 0px">
                            { paramedicalsReimbursementString }
                        </Text>
                    </div>

                    {
                        familyCombinedMaximumString &&
                            <div style={classes.row}>
                                <Text small bold margin="10px 0px 10px 0px">
                                    { familyCombinedMaximumString }
                                </Text>
                            </div>
                    }

                    {
                        hasDeductible ? 
                            defineCoverageType()
                            : 
                            null
                    }

                    <CoverageBlock
                        title={ i18n.t(tokens.labels.coverage.benefit)}
                        value={ i18n.t(tokens.labels.maximum) }
                        type="header"
                        isCombined={paramedicals.combinedMaximum !== 0}
                    />

                    <CoverageBlockFull
                        coverage={paramedicals}
                        isCombined={paramedicals.combinedMaximum !== 0}
                    />

                    {
                        paramedicals.hasMentalWellnessGrouped ?
                            <>
                                <div style={classes.row}>
                                    <Text small bold margin="10px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.mentalWellness, { mentalWellnessReimbursement: paramedicals.mentalWellnessReimbursement, mentalWellnessMaximum: paramedicals.mentalWellnessMaximum })}
                                    </Text>
                                </div>

                                <Text small margin="0px 0px 10px 0px">
                                    { i18n.t(tokens.dropdowns.benefits.socialWorker) }*
                                </Text>
                                <Text small margin="0px 0px 10px 0px">
                                    { i18n.t(tokens.dropdowns.benefits.psychologist) }*
                                </Text>
                                <Text small margin="0px 0px 10px 0px">
                                    { i18n.t(tokens.dropdowns.benefits.psychotherapist) }*
                                </Text>
                            </>
                            :
                            null
                    }

                    {
                        paramedicals.hasFunctionalTreatmentGrouped ?
                            <>
                                <div style={classes.row}>
                                    <Text small bold margin="10px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.functionalTreatmentMaximum, { functionalTreatmentReimbursement: paramedicals.functionalTreatmentReimbursement, functionalTreatmentMaximum: paramedicals.functionalTreatmentMaximum })}
                                    </Text>
                                </div>

                                <Text small margin="0px 0px 10px 0px">
                                    { i18n.t(tokens.dropdowns.benefits.osteopath) }*
                                </Text>
                                <Text small margin="0px 0px 10px 0px">
                                    { i18n.t(tokens.dropdowns.benefits.chiropodist) }*
                                </Text>
                                <Text small margin="0px 0px 10px 0px">
                                    { i18n.t(tokens.dropdowns.benefits.podiatrist) }*
                                </Text>
                            </>
                            :
                            null
                    }

                    <Text small bold margin="10px 0px 0px 0px">
                        <>
                            { i18n.t(tokens.labels.coverage.paramedicalTelusLookupOne) }
                            { 
                                <a href="https://plus.telushealth.co/page/eclaims/discover/" target="_blank" rel="noreferrer" style={{ color: store.getState().whitelabel.secondaryColor || Theme.colors.skyBlue }} >
                                    {i18n.t(tokens.labels.coverage.paramedicalTelusLookupTwo)}
                                </a> 
                            }
                            { i18n.t(tokens.labels.coverage.paramedicalTelusLookupThree) }
                        </>
                    </Text>

                    <Text small bold margin="10px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.paramedicalInfo) }
                    </Text>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}